import React from 'react'
import axios from 'axios';
import utils from '../Utils';
import { Button } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { Link } from 'react-router-dom'
import BusinessRoundedIcon from '@material-ui/icons/BusinessRounded';
import RingVolumeRoundedIcon from '@material-ui/icons/RingVolumeRounded';

import style from 'style/Hospital.css'

class Hospital extends React.Component {
  componentDidMount() {

  }
  fullName = (patient) => {
    return patient.fname + ((patient.lname && patient.fname) && ' ') + patient.lname
  }
  showQuiz = (quizId) => {

  }
  render() {
    return (
      <div class="hospital-item card">
        <div class='hospital-name'>
          بیمارستان امام خمینی
        </div>
        <div class='address hospital-row'>
          <BusinessRoundedIcon style={{ color: '#007fca' }}></BusinessRoundedIcon>
          <span>تهران نبش بلوار کشاورز پلاک 80</span>
        </div>
        <div class='tel hospital-row'>
          <RingVolumeRoundedIcon style={{ color: '#007fca' }}></RingVolumeRoundedIcon>
          <span>4485837363 - 883773663</span>
        </div>
        <div class='hospital-row btn'>
          <img src='/images/waze.png' />
          <span>مسیر یابی با ویز</span>
        </div>
        <div class='hospital-row btn'>
          <img src='/images/google-maps.png' />
          <span>مسیر یابی با گوگل مپ</span>
        </div>

      </div>
    )
  }
}
export default Hospital;